module.exports = __webpack_public_path__ + "static/media/add.b72dab36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/add.svg
// module id = 617
// module chunks = 0